<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="业务号">
              <div class="custom-select-container">
                <a-input
                  allow-clear
                  placeholder="请输入"
                  v-model="queryParam.business_no"
                >
                </a-input>
              </div>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="采销全流程">
              <a-select
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                show-search
                allow-clear
                v-model="queryParam.project_id"
                placeholder="请输入名称"
                :default-active-first-option="false"
                @search="this.projectSearch"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id" :tt="d.name">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24" v-if="false">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleArchived">批量存档</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24" v-if="true">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1200 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="money_render" slot-scope="text, record" style="text-align: right; min-width: 90px; max-width: 200px">
        {{ (text / 1).toFixed(4) | numberFormat }}
        {{ $Dictionaries.currency[record.business_currency] || '无' }}
      </div>
      <div slot="business_amount" slot-scope="text" style="text-align: right; min-width: 90px; max-width: 200px">
        {{ (text / 1).toFixed(4) | numberFormat }} %
      </div>
      <div slot="weight_render" slot-scope="text, record" style="text-align: right; min-width: 90px; max-width: 200px">
        {{ (text / 1).toFixed(4) | numberFormat }}
        {{ $Dictionaries.unit[record.business_currency] || '无' }}
      </div>
      <div slot="planned_exposure_amount_render" slot-scope="text, record" style="text-align: right; min-width: 90px; max-width: 200px">
        {{ (text / 1).toFixed(4) | numberFormat }}
        {{ $Dictionaries.currency[record.planned_exposure_currency] || '无' }}
      </div>
      <div slot="letter_credit_type_render" slot-scope="text, record" style="text-align: center;">
        <a-tag v-if="text === 1" color="red">
          {{ $Dictionaries.letter_credit_types[text] || '无' }}
        </a-tag>
        <a-popover title="远期" v-else>
          <template slot="content">
            远期天数: <p>{{ record.usance_days }} （天）</p>
          </template>
          <a-tag color="blue">
            {{ $Dictionaries.letter_credit_types[text] || '无' }}
          </a-tag>
        </a-popover>
      </div>
      <div slot="according_contract" slot-scope="text, record" >
        <a-tag v-if="text" color="blue">
          是
        </a-tag>
        <a-popover title="46A单据要求" v-else>
          <template slot="content">
            <p>{{ record.documents_required }}</p>
          </template>
          <a>
            否
          </a>
        </a-popover>
      </div>
      <span slot="approval_needed" slot-scope="text, record">
        <a-popconfirm
          title="确定开启审批吗?"
          :disabled="text"
          @confirm="() => approvalNeeded(record, undefined, false)">
          <a-switch checked-children="是" un-checked-children="否" :checked="record.is_approval_needed" :disabled="record.is_approval_needed"/>
        </a-popconfirm>
      </span>
      <span slot="archived" slot-scope="text, item">
        <a-popconfirm
          title="确定存档吗?"
          :disabled="text"
          @confirm="() => archived(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
        </a-popconfirm>
      </span>
      <span slot="action" slot-scope="text, record" v-if="!record.is_archived">
        <template>
          <a @click="handleEdit(record)" v-if="record.status === 0 && isEdited(record.create_by_id)">编辑</a>
          <a-divider type="vertical" v-if="record.status !== 1 && isEdited(record.create_by_id)"/>
          <a-popconfirm
            v-if="record.status !== 1 && isEdited(record.create_by_id)"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" v-if="record.is_approval_needed && record.status === 3 && isEdited(record.create_by_id)"/>
          <a-popconfirm
            v-if="record.is_approval_needed && record.status === 3 && isEdited(record.create_by_id)"
            title="确定重启审批?"
            @confirm="() => approvalNeeded(record, 'lc_application', true)">
            <span>重启审批</span>
          </a-popconfirm>
          <a-divider type="vertical" v-if="record.status !== 1 && isEdited(record.create_by_id)"/>
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多 <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleAttachment(record)">附件</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleIssue(record)" v-if="(record.is_approval_needed && record.status === 2) || (!record.is_approval_needed && record.status === 0)">开具信用证</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleBill(record)" v-if="(record.is_approval_needed && record.status === 2) || (!record.is_approval_needed && record.status === 0)">银承/商承</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </span>
    </s-table>
    <lc-application-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <archived-form
      ref="archivedModal"
      v-if="archivedVisible"
      :visible="archivedVisible"
      @cancel="handleArchivedCancel"
      @ok="handleArchivedOK"
    />
    <lc-issue-form
      ref="createLcIssueModal"
      v-if="issueVisible"
      :visible="issueVisible"
      :loading="confirmLcIssueLoading"
      :model="mdl"
      @cancel="handleLcIssueAddCancel"
      @ok="handleLcIssueOk"/>
  </div>
</template>

<script>
import { STable } from '@/components'
import LcApplicationForm from '../modules/LcApplicationForm'
import LcIssueForm from '../modules/LcIssueForm'
import {
  lc_application_create,
  lc_application_delete,
  lc_application_update, lc_application_list
} from '@/api/trade_credit_letter'
import debounce from 'lodash/debounce'
import { project_list } from '@/api/trade_project'

export default {
  name: 'TableList',
  components: {
    STable,
    LcApplicationForm,
    LcIssueForm
  },
  data () {
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      approval_again: false,
      loading: false,
      confirmLoading: false,
      // 创建窗口控制
      visible: false,
      archivedVisible: false,
      issueVisible: false,
      confirmLcIssueLoading: false,
      projectFetching: false,
      mdl: {},
      projectList: [],
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '业务号',
          dataIndex: 'business_no',
          width: 150,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '采销全流程',
          dataIndex: 'project',
          width: 150,
          ellipsis: true
        },
        {
          title: '购销合同',
          dataIndex: 'sell_contract',
          width: 150,
          ellipsis: true
        },
        {
          title: '授信银行',
          dataIndex: 'issuing_bank',
          width: 180,
          ellipsis: true
        },
        {
          title: '银行业务品种',
          dataIndex: 'bank_services_type',
          width: 180,
          ellipsis: true,
          align: 'center',
          customRender: text => this.$Dictionaries.bank_services_types[text] || '无'
        },
        {
          title: '业务金额',
          dataIndex: 'business_amount',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '拟占用敞口金额',
          dataIndex: 'planned_exposure_amount',
          scopedSlots: { customRender: 'planned_exposure_amount_render' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '金额溢装',
          dataIndex: 'business_amount_more_clause',
          scopedSlots: { customRender: 'business_amount' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '金额短装',
          dataIndex: 'business_amount_less_clause',
          scopedSlots: { customRender: 'business_amount' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '保证金比例',
          dataIndex: 'margin_ratio',
          width: 180,
          align: 'right',
          ellipsis: true,
          customRender: (text) => text + ' %'
        },
        {
          title: '保证金来源',
          dataIndex: 'margin_source',
          width: 180,
          align: 'center',
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.margin_resources[text]
        },
        {
          title: '开证时间',
          dataIndex: 'lc_date',
          width: 150,
          ellipsis: true,
          customRender: (text) => text === '1970-01-01' ? '' : text
        },
        {
          title: '通知行',
          dataIndex: 'advising_bank',
          width: 150,
          ellipsis: true
        },
        {
          title: '装港',
          dataIndex: 'loading_port',
          width: 150,
          ellipsis: true
        },
        {
          title: '卸港',
          dataIndex: 'discharge_port',
          width: 150,
          ellipsis: true
        },
        {
          title: '最晚装货期',
          dataIndex: 'latest_shipment_date',
          width: 150,
          ellipsis: true,
          customRender: (text) => text === '1970-01-01' ? '无' : text
        },
        {
          title: '交单期',
          dataIndex: 'presentation_period',
          width: 150,
          ellipsis: true
        },
        {
          title: '分批装运',
          dataIndex: 'is_partial_shipment',
          width: 120,
          align: 'center',
          customRender: (text) => text ? '是' : '否'
        },
        {
          title: '转运',
          dataIndex: 'is_transfer_shipment',
          width: 120,
          align: 'center',
          customRender: (text) => text ? '是' : '否'
        },
        {
          title: '45A货描',
          dataIndex: 'goods_services_desc',
          width: 150,
          ellipsis: true
        },
        {
          title: '是否按照合同填写',
          dataIndex: 'is_according_contract',
          width: 150,
          align: 'center',
          scopedSlots: { customRender: 'according_contract' }
        },
        {
          title: '47A其他单据要求',
          dataIndex: 'additional_conditions',
          width: 180,
          ellipsis: true
        },
        {
          title: '已存档',
          dataIndex: 'is_archived',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'archived' }
        },
        {
          title: '开启审批',
          dataIndex: 'is_approval_needed',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'approval_needed' }
        },
        {
          title: '审批状态',
          dataIndex: 'status',
          align: 'center',
          width: 100,
          customRender: (text, record) => record.is_approval_needed ? this.$Dictionaries.approval_result[text] || '无' : '未开启审批'
        },
        {
          title: '创建人',
          dataIndex: 'create_by',
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: 180,
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData.parameter', parameter)
        return lc_application_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            console.log(res.data, '我是数据列表@')
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          getCheckboxProps: record => ({
            props: {
              disabled: record.is_archived
            }
          }),
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    if (this.$route.query && this.$route.query.id) {
      this.queryParam['id'] = this.$route.query.id
    }
  },
  computed: {
    isEdited () {
      return (create_by_id) => {
        const info = this.$store.state.user.info
        return create_by_id === info.id || create_by_id === -1
      }
    }
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            getCheckboxProps: record => ({
              props: {
                disabled: record.is_archived
              }
            }),
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      const date = new Date()
      const year = date.getFullYear()
      const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
      const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      // const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      // const second = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
      this.mdl = { business_no: year + '' + month + '' + day + '' + hours }
      this.visible = true
    },
    handleArchived () {
      if (this.selectedRowKeys.length > 0) {
        this.archivedVisible = true
      } else {
        this.$message.info('选择存档记录')
      }
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleArchivedCancel () {
      this.archivedVisible = false
      const form = this.$refs.archivedModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleLcIssueAddCancel () {
      this.issueVisible = false
      const form = this.$refs.createLcIssueModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleLcIssueOk () {
      const form = this.$refs.createLcIssueModal.form
      this.confirmLcIssueLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          // 新增
          lc_application_create(values).then(res => {
            this.visible = false
            // 重置表单数据
            form.resetFields()
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.confirmLcIssueLoading = false
          })
        } else {
          this.confirmLcIssueLoading = false
        }
      })
    },
    handleEdit (record) {
      this.$router.push({ path: '/trade/lc_application/' + record.id })
    },
    archived (record) {
      lc_application_update({ id: record.id, is_archived: !record.is_archived }).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    approvalNeeded (record, type, approval_again) {
      const is_approval_needed = approval_again ? true : !record.is_approval_needed
      if (is_approval_needed) {
        this.loading = true
        lc_application_update({ is_approval_needed: is_approval_needed }, record.id).then(res => {
          if (res.code === 1000) {
            this.$refs.table.refresh()
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    handleDelete (record) {
      lc_application_delete(record.id).then((res) => {
        console.log(res)
        if (res.code === 1000) {
          console.log('删除成功------')
          this.$refs.table.refresh()
        }
      })
    },
    handleAttachment (record) {
      // 附件
      this.$router.push({ path: '/trade/lc_application/' + record.id + '/attachment' })
    },
    handleIssue (record) {
      // 信用证开具
      // this.$router.push({ path: '/trade/credit_letter/', query: { lc_application_id: record.id } })
      this.$router.push({ path: '/trade/lc_issue/', query: { lc_application_id: record.id } })
      // // 信用证开具
      // this.mdl = record
      // this.mdl['application'] = record
      // this.issueVisible = true
    },
    handleBill (record) {
      console.log(record)
      this.$router.push({ path: '/trade/bank_commercial_acceptance/', query: { lc_application_id: record.id } })
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
            // 新增
          if (data.attachment) {
            const attachment = data.attachment.map(item => {
              item['key'] = undefined
              return item
            })
            values = { ...values, 'attachment': attachment }
            console.log(values)
          }
          values['contract_type'] = values['contract_type'].join(',')
          this.confirmLoading = true
          lc_application_create(values).then(res => {
              // 刷新表格
              if (res.code === 1000) {
                this.$refs.table.refresh()
                this.visible = false
                // 重置表单数据
                form.resetFields()
              }
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleProjectSearch (value) {
      if (value === undefined || value === '') {
        return
      }
      this.projectFetching = true
      this.projectList = []
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleArchivedOK () {
      const form = this.$refs.archivedModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          const data = {
            ids: this.selectedRowKeys,
            ...values
          }
          lc_application_update(data).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.archivedVisible = false
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>
